import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { userHavePermission } from "~Services/Helpers";
import { isEmpty } from "~Services/Helpers/isEmpty";
import { useGetRequest } from "../../../../Hooks/Queries";
import { changeUser } from "../../../../store/app/User";
// import GeneralLoader from "../../../UI/GeneralLoader";
import { AppCrashedComponent } from "../../../ErrorBoundary/Partials";

function PrivateRoute(rest) {
  const user = useSelector((state) => state?.app?.user)
  const dispatch = useDispatch()

  const {
    data: responseGetRequest,
    error,
    refetch,
    isError,
    isLoading,
    isRefetching
  } = useGetRequest({
    url: "user.me",
    queryKey: 'me',
    enabled: true
    // headers: {
    //   Authorization: user?.token
    // }
  });

  // console.log('responseGetRequest', responseGetRequest)

  useEffect(() => {
    if (!!responseGetRequest?.payload?.roles?.length > 0) {

      const roles = responseGetRequest?.payload?.roles || [];
      const isAdmin = roles.find((r) => r?.key === 'admin');
      const perms = roles.flatMap((r) => (r?.permissions || []).map((p) => p.key));
      const role = roles.length ? [...perms, isAdmin?.key].filter(Boolean) : null;

      // console.log('role', role)
      // setRole(JSON.stringify([...role]));

      dispatch(
        changeUser(
          {
            roles: role
          }
        )
      )
    }
  }, [responseGetRequest])

  // const userpermissions = !isEmpty(user?.role)
  //   ? user?.role
  //   : [];
  let itemPermissions = Array.isArray(rest?.permission)
    ? rest?.permission
    : [rest?.permission];

  // if (!user?.token) return <Navigate to="/" exact />
  // if ((!!isLoading || !!isRefetching) && !!isEmpty(user?.role)) {
  //   return <GeneralLoader />
  // } else if (!!error && !!isEmpty(user?.role)) {
  //   return <AppCrashedComponent />
  // } else {
  return !!user?.token ? (
    !isEmpty(user?.roles) ? (
      userHavePermission(!!error ? user?.roles : user?.roles, itemPermissions) ? (
        <Outlet />
      ) : (
        <Navigate to="/error/404" />
        // )
      )) : <AppCrashedComponent />
  ) : (
    <Navigate to="/" exact />
  );
}
// }

export default PrivateRoute;
